import { css } from 'styled-components'

export const roleCellStyle = css`
	display: flex;
	height: 100%;
	justify-content: flex-start;
	align-items: center;
	flex-direction: row;
	gap: 5px;
	/* A user with two roles overflowed this cell once the Sign-in column took
	   width off it. Clip rather than push the row around. */
	overflow: hidden;
`

export const roleCellItemStyle = css`
	background-color: #e6e6e6;
	padding: 4px 10px;
	color: #7e7e80;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	text-transform: uppercase;
	border-radius: 16px;
	/* Without these the pill is a shrinkable flex item: in a narrow cell it
	   compresses and "ACCOUNT MANAGER" breaks onto a second line, making the pill
	   taller than the row it sits in. Chips keep their own width and stay on one
	   line; the cell above clips if there is genuinely no room. */
	white-space: nowrap;
	flex-shrink: 0;
`
